import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./shop-manager/shop-manager.module').then((m)=> m.ShopManagerModule),
  },
  {
    path: 'event',
    loadChildren: () =>
      import('./shop-manager/shop-manager.module').then((m)=> m.ShopManagerModule),
  },
  {
    path: 'registration',
    loadChildren: () =>
      import(
        './modules/registration-module/registration-module.module'
      ).then((m) => m.RegistrationModuleModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import(
        './modules/login-module/login-module.module'
      ).then((m) => m.LoginModuleModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./layout-manager/layout-manager.module').then((m)=> m.LayoutManagerModule),
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
